import { updateObject, objectArrayToObject, getIndex } from './../../utils/utility';
import { COUNTRY_CODE, DEFAULT_STATE_INFO, REGION_CODE } from '../../libs/constants';
import  AppConfigData from '../../libs/app-config.json';
import { transformMaterialsData, validateUserMaterialSelection, hazardousItemsExistIn } from '../../libs/data-transform';
import update from 'immutability-helper';
import { isArray, concat, uniq, includes } from 'lodash';
import { costDisplayRules } from '../../libs/cost-display-logic';

const initialState = {
    leftOverOrder: false,
    repeatOrder: false,
    quoteToOrder: false,
    leftOverSaveQuoteRequest: false,
    orderType: 1, // schedule : 1, ship : 2
    currentStep: 0,
    totalConfigs: 1,
    configData0: null,
    configData1: null,
    configData2: null,
    configData3: null,
    configData4: null,
    configData5: null,
    configData6: null,
    scheduleDate: new Date(),
    scheduleShift: "morning",
    collectionInfoData: {
        addressId: "",
        email: "",
        contactNo: "",
        cellPhoneNumber: "",
        firstName: "",
        lastName: "",
        company: "",
        addressLine1: "",
        addressLine2: "",
        streetType: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        staircase: "",
        door: "",
        city: "",
        state: DEFAULT_STATE_INFO && DEFAULT_STATE_INFO.id,
        country: COUNTRY_CODE,
        zipCode: "",
        personalTaxId: "",
        companyTaxId: "",
        envId: "",
        comment: "",
        shippingAndReceivingHours: "",
        wasteProducerRegistration: false,
        emanifestCode: "",
        consent: false,
        subscription: false,
        surveyConsent: false,
        saveAddress: false,
        formValid: false
    },
    addressData: {
        addressId: "",
        email: "",
        contactNo: "",
        cellPhoneNumber: "",
        firstName: "",
        lastName: "",
        company: "",
        addressLine1: "",
        addressLine2: "",
        streetType: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        staircase: "",
        door: "",
        city: "",
        state: DEFAULT_STATE_INFO && DEFAULT_STATE_INFO.id,
        country: COUNTRY_CODE,
        zipCode: "",
        personalTaxId: "",
        companyTaxId: "",
        envId: "",
        comment: "",
        shippingAndReceivingHours: "",
        wasteProducerRegistration: false,
        emanifestCode: "",
        consent: false,
        subscription: false,
        surveyConsent: false,
        saveAddress: false,
        formValid: false
    },
    useCollectionAddressAsBilling: false,
    addressDataCopy: null,
    orderConfirmationId: null,
    confirmCaptcha: false,
    scheduleStartDate: null,
    scheduleEndDate: null,
    scheduleTimeSlot: "",
    firstTimeIndicator: "Y",
    hasHazardousCategories: false,
    checkedMaterialsList: [],
    clearedMaterialsList: [],
    orderAttempted: false,
    orderSuccess: false,
    orderCreateResponse: null,
    orderStatus: null,
    isGenerateQuoteClicked: false
};

const setSelectedCategories = (state = initialState, action) => {
    return updateObject(state, {
        selectedCategories: action.data
    });
}

const updateAddressData = (state = initialState, action) => {
    const { data, addressType } = action.data;
    return updateObject(state, {
        [addressType]: updateObject(state[addressType], data)
    });
}

const setOrderType = (state = initialState, action) => {
    return updateObject(state, {
        orderType: action.data,
        serviceSelectionRequired: false
    });
}

const setServiceType = (state = initialState, action) => {
    return updateObject(state, {
        serviceType: action.data
    });
}

const setFirstTimeIndicator = (state = initialState, action) => {
    return updateObject(state, {
        firstTimeIndicator: action.data
    });
}

const setLeftOverOrder = (state = initialState, action) => {
    return updateObject(state, {
        leftOverOrder: action.data
    });
}

const setCurrentStep = (state = initialState, action) => {
    return updateObject(state, {
        currentStep: action.data
    });
}

const resetOrder = (state = initialState) => {
    return updateObject(state, initialState);
}

const updateAddressFormField = (state = initialState, action) => {
    // expects object in this format => { fieldName: fieldValue } For example { firstName: "John" }
    const { data, addressType } = action.data;

    const fieldName = Object.keys(data)[0];
    if (state[addressType].hasOwnProperty(fieldName)) {
        return updateObject(state, {
            [addressType]: updateObject(state[addressType], {
                [fieldName]: data[fieldName]
            })
        });
    }

    return state;
}

const setConfirmCaptcha = (state, action) => {
    let updatedObject = updateObject(state, {
        confirmCaptcha: action.data
    });
    return updatedObject;
}

const setOrderAttempted = (state, action) => {
    let updatedObject = updateObject(state, {
        orderAttempted: action.data
    });
    return updatedObject;
}

const setQuoteRefreshed = (state, action) => {
    let updatedObject = updateObject(state, {
        quoteRefreshed: action.data
    });
    return updatedObject;
}

const setOrderCreateData = (state, action) => {
    const orderSuccess = action.payload.errorCode ? false : true;

    let updatedObject = updateObject(state, {
        orderAttempted: true,
        leftOverOrder: false,
        orderSuccess: orderSuccess,
        orderCreateResponse: action.payload,
        orderStatus: action.payload.status ? action.payload.status : "",
        orderConfirmationId: action.payload.orderId ? action.payload.orderId : null
    });
    return updatedObject;
}

const setOrderStatus = (state, action) => {
    let updatedObject = updateObject(state, {
        orderStatus: action.payload.status ? action.payload.status : ""
    });
    return updatedObject;
}

const setScheduleDate = (state = initialState, action) => {
    return updateObject(state, {
        scheduleDate: action.data
    });
}

const setScheduleShift = (state = initialState, action) => {
    return updateObject(state, {
        scheduleShift: action.data
    });
}

const setScheduleTimeSlot = (state = initialState, action) => {
    return updateObject(state, {
        scheduleTimeSlot: action.data
    });
}

const setOrderData = (state = initialState, action) => {
    const { type, orderData } = action.data;
    if (type === "leftover") {
        return updateObject(state, updateObject(
            orderData, { leftOverOrder: true }
        ));
    }
    else {
        return state;
    }
}

const setQuoteSaved = (state = initialState, action) => {
    return updateObject(state, {
        quoteSaved: true,
        quoteData: action.payload
    });
}

const setTotalConfigs = (state = initialState, action) => {
    return updateObject(state, {
        totalConfigs: action.data
    });
}

const updateConfigData = (state = initialState, action) => {
    const { configId, configData } = action.data;
    return updateObject(state, {
        [configId]: configData
    });
}

const setUseCollectionAddressAsBilling = (state = initialState, action) => {
    return updateObject(state, {
        useCollectionAddressAsBilling: action.data
    });
}

const setAddressDataCopy = (state = initialState) => {
    if (state.addressDataCopy) return state; // only set copy if its null

    return updateObject(state, {
        addressDataCopy: state.addressData
    });
}

const setLeftOverSaveQuoteRequest = (state = initialState, action) => {
    return updateObject(state, {
        leftOverSaveQuoteRequest: action.data ? true : false
    });
}

const resetOrderData = (state = initialState) => {
    return updateObject(state, initialState);
}

const isGenerateQuoteClicked = (state = initialState, action) => {
    return updateObject(state, { isGenerateQuoteClicked: action.status });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_SELECTED_CATEGORIES") {
        return setSelectedCategories(state, action)
    }
    else if (action.type === "SET_ORDER_TYPE") {
        return setOrderType(state, action)
    }
    else if (action.type === "SET_SERVICE_TYPE") {
        return setServiceType(state, action)
    }
    else if (action.type === "SET_FIRST_TIME_INDICATOR") {
        return setFirstTimeIndicator(state, action)
    }
    else if (action.type === "SET_CURRENT_STEP") {
        return setCurrentStep(state, action);
    }
    else if (action.type === "RESET_ORDER") {
        return resetOrder(state);
    }
    else if (action.type === "UPDATE_ADDRESS_FORM_FIELD") {
        return updateAddressFormField(state, action);
    }
    else if (action.type === "UPDATE_ADDRESS_DATA") {
        return updateAddressData(state, action);
    }
    else if (action.type === "SET_CAPTCHA") {
        return setConfirmCaptcha(state, action);
    }
    else if (action.type === "SET_SCHEDULE_DATE") {
        return setScheduleDate(state, action);
    }
    else if (action.type === "SET_SCHEDULE_TIME_SLOT") {
        return setScheduleTimeSlot(state, action);
    }
    else if (action.type === "SET_ORDER_ATTEMPTED") {
        return setOrderAttempted(state, action);
    }
    else if (action.type === "SET_QUOTE_REFRESHED") {
        return setQuoteRefreshed(state, action);
    }
    else if (action.type === "SET_NEW_ORDER_CREATED") {
        return setOrderCreateData(state, action);
    }
    else if (action.type === "SET_ORDER_STATUS") {
        return setOrderStatus(state, action);
    }
    else if (action.type === "SET_ORDER_DATA") {
        return setOrderData(state, action);
    }
    else if (action.type === "SET_LEFT_OVER_ORDER") {
        return setLeftOverOrder(state, action);
    }
    else if (action.type === "SET_NEW_ORDER_QUOTE_DATA") {
        return setQuoteSaved(state, action);
    }
    else if (action.type === "SET_TOTAL_CONFIGS") {
        return setTotalConfigs(state, action);
    }
    else if (action.type === "UPDATE_CONFIG_DATA") {
        return updateConfigData(state, action);
    }
    else if (action.type === "SET_SCHEDULE_SHIFT") {
        return setScheduleShift(state, action);
    }
    else if (action.type === "SET_USE_COLLECTION_ADDRESS_AS_BILLING") {
        return setUseCollectionAddressAsBilling(state, action);
    }
    else if (action.type === "SET_ADDRESS_DATA_COPY") {
        return setAddressDataCopy(state);
    }
    else if (action.type === "SET_LEFT_OVER_SAVE_QUOTE_REQUEST") {
        return setLeftOverSaveQuoteRequest(state, action);
    }
    else if (action.type === "RESET_ORDER_DATA") {
        return resetOrderData(state);
    }
    else if (action.type === "IS_GENERATE_QUOTE_CLICKED") {
        return isGenerateQuoteClicked(state, action);
    }

    return state;
}

export default reducer;